module.exports = "/_next/static/images/sekiya_napolitan-7e0640b5d46decf582e504648ae11a26.jpg";